import {
  Component,
  Input,
} from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { debounceTime } from 'rxjs/operators';
import { ValidationService } from '@shared/services/validation.service';
@UntilDestroy()
@Component({
  selector: 'app-custom-error',
  templateUrl: './custom-error.component.html',
  standalone:false
})
export class CustomErrorComponent {
  @Input() height = 'h-[1px]';
  constructor(private validationService: ValidationService) {}

  _control: AbstractControl; // FormControl;
  error = '';
  @Input() public set control(v:AbstractControl) {
    this._control = v;
    this._control?.valueChanges
      .pipe(debounceTime(1000))
      .pipe(untilDestroyed(this))
      .subscribe(() => (this.error = this.getControlError()));
  }

  private _label: string;
  private _force: boolean;

  @Input() public set label(v: string) {
    this._label = v;
  }
  @Input() public set force(v: boolean) {
    this._force = v;
    if (this._force) this.error = this.getControlError();
  }
  @Input() public set errorMessage(errorMessage: string) {
    this.error = errorMessage;
  }
  getControlError() {
    return this.validationService.getValidationError(
      this._control,
      this._label,
      this._force
    );
  }
}
